import React from 'react'

export default function NotifItem({actor, action, time}) {
    return (
        <div className='bg-white text-sm flex gap-2 p-5 justify-between items-center text-gray-800'>
            <img src={require('../assets/person_lady.png')} />
            <div>
                <span className='font-semibold'>{actor}</span> {action}
            </div>
            <div className='text-gray-400'>
                {time}
            </div>
        </div>
    )
}
